module.exports = __webpack_public_path__ + "img/icon-role.ae3950c7.svg";